import React from "react";
import { Link } from "react-router-dom";

const TablePagination = ({ table }) => {
  const { pageIndex, pageSize } = table.getState().pagination;
  const totalRows = table.getFilteredRowModel().rows.length;
  const firstRow = pageIndex * pageSize + 1;
  const lastRow = Math.min((pageIndex + 1) * pageSize, totalRows);

  return (
    <div className="row gy-2 mt-2 px-4">
      <div className="col-sm-12 col-md-5 p-2">
        <div
          className="dataTables_info text-lg-start text-center"
          id="proposalList_info"
          role="status"
          aria-live="polite"
        >
          {totalRows > 0
            ? `Showing ${firstRow} to ${lastRow} of ${totalRows} entries`
            : "No entries to show"}
        </div>
      </div>
      <div className="col-sm-12 col-md-7 p-2">
        <div
          className="dataTables_paginate paging_simple_numbers"
          id="proposalList_paginate"
        >
          <ul className="pagination mb-0 justify-content-md-end justify-content-center">
            <li
              className={`paginate_button page-item previous ${
                !table.getCanPreviousPage() ? "disabled" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                table.getCanPreviousPage() && table.previousPage();
              }}
            >
              <a href="#" className="page-link">
                Previous
              </a>
            </li>

            <li className="paginate_button page-item active">
              <Link to="#" className="page-link">
                {pageIndex + 1}
              </Link>
            </li>

            <li
              className={`paginate_button page-item next ${
                !table.getCanNextPage() ? "disabled" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                table.getCanNextPage() && table.nextPage();
              }}
            >
              <a href="#" className="page-link">
                Next
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TablePagination;
